var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"font-medium btn-view",on:{"click":function($event){return _vm.showModal()}}},[_vm._v("\n    View Code\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }